module.exports = __webpack_public_path__ + "static/actions-480bb62da8f8e6dbe62b44fa6bb59161.png";